export const dataBook = {
  1: [[{ imgUrl: "img/FriendPlus/ListPage/1.jpg", excerciseNum: 0 }]],
  2: [[{ imgUrl: "img/FriendPlus/ListPage/2.jpg", excerciseNum: 0 }]],
  3: [[{ imgUrl: "img/FriendPlus/ListPage/3.jpg", excerciseNum: 0 }]],
  4: [[{ imgUrl: "img/FriendPlus/ListPage/4.jpg", excerciseNum: 0 }]],
  5: [[{ imgUrl: "img/FriendPlus/ListPage/5.jpg", excerciseNum: 0 }]],
  6: [[{ imgUrl: "img/FriendPlus/ListPage/6.jpg", excerciseNum: 0 }]],
  7: [[{ imgUrl: "img/FriendPlus/ListPage/7.jpg", excerciseNum: 0 }]],
  8: [[{ imgUrl: "img/FriendPlus/ListPage/8.jpg", excerciseNum: 0 }]],
  9: [[{ imgUrl: "img/FriendPlus/ListPage/9.jpg", excerciseNum: 0 }]],
  10: [[{ imgUrl: "img/FriendPlus/ListPage/10.jpg", excerciseNum: 0 }]],
  11: [[{ imgUrl: "img/FriendPlus/ListPage/11.jpg", excerciseNum: 0 }]],
  12: [[{ imgUrl: "img/FriendPlus/ListPage/12.jpg", excerciseNum: 0 }]],
  13: [[{ imgUrl: "img/FriendPlus/ListPage/13.jpg", excerciseNum: 0 }]],
  14: [[{ imgUrl: "img/FriendPlus/ListPage/14.jpg", excerciseNum: 0 }]],
  15: [[{ imgUrl: "img/FriendPlus/ListPage/15.jpg", excerciseNum: 0 }]],
  16: [[{ imgUrl: "img/FriendPlus/ListPage/16.jpg", excerciseNum: 0 }]],
  17: [[{ imgUrl: "img/FriendPlus/ListPage/17.jpg", excerciseNum: 0 }]],
  18: [[{ imgUrl: "img/FriendPlus/ListPage/18.jpg", excerciseNum: 0 }]],
  19: [[{ imgUrl: "img/FriendPlus/ListPage/19.jpg", excerciseNum: 0 }]],
  20: [[{ imgUrl: "img/FriendPlus/ListPage/20.jpg", excerciseNum: 0 }]],
  21: [[{ imgUrl: "img/FriendPlus/ListPage/21.jpg", excerciseNum: 0 }]],
  22: [[{ imgUrl: "img/FriendPlus/ListPage/22.jpg", excerciseNum: 0 }]],
  23: [[{ imgUrl: "img/FriendPlus/ListPage/23.jpg", excerciseNum: 0 }]],
  24: [[{ imgUrl: "img/FriendPlus/ListPage/24.jpg", excerciseNum: 0 }]],
  25: [[{ imgUrl: "img/FriendPlus/ListPage/25.jpg", excerciseNum: 0 }]],
  26: [[{ imgUrl: "img/FriendPlus/ListPage/26.jpg", excerciseNum: 0 }]],
  27: [[{ imgUrl: "img/FriendPlus/ListPage/27.jpg", excerciseNum: 0 }]],
  28: [[{ imgUrl: "img/FriendPlus/ListPage/28.jpg", excerciseNum: 0 }]],
  29: [[{ imgUrl: "img/FriendPlus/ListPage/29.jpg", excerciseNum: 0 }]],
  30: [[{ imgUrl: "img/FriendPlus/ListPage/30.jpg", excerciseNum: 0 }]],
  31: [[{ imgUrl: "img/FriendPlus/ListPage/31.jpg", excerciseNum: 0 }]],
  32: [[{ imgUrl: "img/FriendPlus/ListPage/32.jpg", excerciseNum: 0 }]],
  33: [[{ imgUrl: "img/FriendPlus/ListPage/33.jpg", excerciseNum: 0 }]],
  34: [[{ imgUrl: "img/FriendPlus/ListPage/34.jpg", excerciseNum: 0 }]],
  35: [[{ imgUrl: "img/FriendPlus/ListPage/35.jpg", excerciseNum: 0 }]],
  36: [[{ imgUrl: "img/FriendPlus/ListPage/36.jpg", excerciseNum: 0 }]],
  37: [[{ imgUrl: "img/FriendPlus/ListPage/37.jpg", excerciseNum: 0 }]],
  38: [[{ imgUrl: "img/FriendPlus/ListPage/38.jpg", excerciseNum: 0 }]],
  39: [[{ imgUrl: "img/FriendPlus/ListPage/39.jpg", excerciseNum: 0 }]],
  40: [[{ imgUrl: "img/FriendPlus/ListPage/40.jpg", excerciseNum: 0 }]],
  41: [[{ imgUrl: "img/FriendPlus/ListPage/41.jpg", excerciseNum: 0 }]],
  42: [[{ imgUrl: "img/FriendPlus/ListPage/42.jpg", excerciseNum: 0 }]],
  43: [[{ imgUrl: "img/FriendPlus/ListPage/43.jpg", excerciseNum: 0 }]],
  44: [[{ imgUrl: "img/FriendPlus/ListPage/44.jpg", excerciseNum: 0 }]],
  45: [[{ imgUrl: "img/FriendPlus/ListPage/45.jpg", excerciseNum: 0 }]],
  46: [[{ imgUrl: "img/FriendPlus/ListPage/46.jpg", excerciseNum: 0 }]],
  47: [[{ imgUrl: "img/FriendPlus/ListPage/47.jpg", excerciseNum: 0 }]],
  48: [[{ imgUrl: "img/FriendPlus/ListPage/48.jpg", excerciseNum: 0 }]],
  49: [[{ imgUrl: "img/FriendPlus/ListPage/49.jpg", excerciseNum: 0 }]],
  50: [[{ imgUrl: "img/FriendPlus/ListPage/50.jpg", excerciseNum: 0 }]],
  51: [[{ imgUrl: "img/FriendPlus/ListPage/51.jpg", excerciseNum: 0 }]],
  52: [[{ imgUrl: "img/FriendPlus/ListPage/52.jpg", excerciseNum: 0 }]],
  53: [[{ imgUrl: "img/FriendPlus/ListPage/53.jpg", excerciseNum: 0 }]],
  54: [[{ imgUrl: "img/FriendPlus/ListPage/54.jpg", excerciseNum: 0 }]],
  55: [[{ imgUrl: "img/FriendPlus/ListPage/55.jpg", excerciseNum: 0 }]],
  56: [[{ imgUrl: "img/FriendPlus/ListPage/56.jpg", excerciseNum: 0 }]],
  
};
